import CaptureEmbed from 'gleam-shared/embeds/CaptureEmbed'

const KEY_ATTR = 'data-lazy-capture-embed'
const SCRIPT_ATTR = 'data-capture-script'

export const SELECTOR = `[${KEY_ATTR}]`
export const NEEDS_PLACEHOLDER = true
export const AWAITS_USER_ACTION = false

export default function loadCaptureEmbed(embed) {
  const key = embed.getAttribute(KEY_ATTR)
  const script = embed.getAttribute(SCRIPT_ATTR)

  return CaptureEmbed(embed, key, script)
}
